import { SortMeta } from 'primeng/api';
import { ColumnSort } from '../../osp-ui/components/data/table/contract/column-sort.contract';

export function convertSortMetaToColumnSort({ field, order }: SortMeta): ColumnSort {
  return {
    field,
    direction: order === 1 ? 'asc' : 'desc',
  };
}
